import { gql } from "@apollo/client";

export const UPDATE_DATOS_UBICACION_ASISTENCIAL = gql`
    mutation updateDatosUbicacionAsistencial(
        $idPaciente: Int!
        $telefono: String!
        $observacion: String!
    ){
        updateDatosUbicacionAsistencial(
            idPaciente: $idPaciente
            telefono: $telefono
            observacion: $observacion
        ){
            idPaciente
        }
    }
`;